import { render, staticRenderFns } from "./ClientOffline.vue?vue&type=template&id=2ed4886b&scoped=true"
import script from "./ClientOffline.vue?vue&type=script&lang=js"
export * from "./ClientOffline.vue?vue&type=script&lang=js"
import style0 from "./ClientOffline.vue?vue&type=style&index=0&id=2ed4886b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed4886b",
  null
  
)

export default component.exports